module.exports = __webpack_public_path__ + "static/media/dk.45a8cdcc.webp";